export enum EDateFormat {
  FORMAT_DDMMYYY = 'DD/MM/YYYY',
  FORMAT_MMDDYYY = 'MM/dd/YYYY',
  MONTH_YEAR_LABEL_MMMYYYY = 'MMM YYYY',
  DATE_ACCESSIBILITY_LABEL_LL = 'LL',
  MONTH_YEAR_ACCESSIBILITY_LABEL_MMMM_YYYY = 'MMMM YYYY',
  EUROPE = 'dd/MM/yyyy'
}

export enum CalendarType {
  Date,
  DateRange
}

export enum CalendarLanguage {
  HE_IL = 'he-IL',
  EN_US = 'en-US'
}
